import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 1rem;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .page-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  .filters {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .filter-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--sl-color-neutral-700);
  }

  .actions {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }

  .error {
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: 6px;
    padding: 1rem;
    color: var(--sl-color-danger-700);
    margin-bottom: 1rem;
  }

  .empty-state {
    text-align: center;
    padding: 3rem;
    color: var(--sl-color-neutral-500);
  }

  .empty-state sl-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: var(--sl-color-neutral-300);
  }

  .empty-state h3 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-600);
  }

  .empty-state p {
    margin: 0;
    font-size: 0.875rem;
  }

  .report-card {
    background: white;
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1rem;
    transition: box-shadow 0.2s ease;
  }

  .report-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .report-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.5rem;
  }

  .report-title {
    font-weight: 600;
    color: var(--sl-color-neutral-900);
    margin: 0;
  }

  .report-meta {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .report-description {
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
    line-height: 1.4;
  }

  .report-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
  }
`;
